import keyMirror from 'keymirror';

export const autonomyActionTypes = keyMirror({
	GET_AUTONOMY_STEPS_REQUEST: null,
	GET_AUTONOMY_STEPS_SUCCESS: null,
	GET_AUTONOMY_STEPS_ERROR: null,

	SET_DRAGGING_STATE: null,

	SAVE_STEPS_POSITION_REQUEST: null,
	SAVE_STEPS_POSITION_SUCCESS: null,
	SAVE_STEPS_POSITION_ERROR: null,

	TOGGLE_AUTONOMY_MODAL: null,

	SAVE_ENGAGE_TIME_REQUEST: null,
	SAVE_ENGAGE_TIME_SUCCESS: null,
	SAVE_ENGAGE_TIME_ERROR: null,
});

export const DRAG_AND_DROP_LAYOUT = 'DRAG_AND_DROP_LAYOUT';
export const DRAG_AND_DROP_LIST = 'DRAG_AND_DROP_LIST';
